import React, { useState, useRef } from "react";
import { ConstructorEventUpdateSQLStatus } from "../../../../Event/event";

const PercentagePracticeGame = () => {
  const [currentLevel, setCurrentLevel] = useState(null);
  const [questionHistory, setQuestionHistory] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(-1);
  const [userAnswer, setUserAnswer] = useState("");
  const [feedback, setFeedback] = useState("");
  const [feedbackClass, setFeedbackClass] = useState("");
  const confettiRef = useRef(null);

  const correctSound = useRef(null);
  const wrongSound = useRef(null);

  const level1Percents = [10, 25, 50];
  const level2Percents = [5, 10, 15, 20];
  const level3Percents = [
    [10, 25],
    [5, 10, 20],
    [15, 20],
  ];

  const startLevel = (level) => {
    setCurrentLevel(level);
    const question = generateQuestion(level);
    setQuestionHistory([question]);
    setCurrentIndex(0);
    setUserAnswer("");
    setFeedback("");
    setFeedbackClass("");
  };

  const generateQuestion = (level) => {
    const number = Math.floor(Math.random() * 91) + 10;
    let percent, combo;

    if (level === 1) {
      percent = level1Percents[Math.floor(Math.random() * level1Percents.length)];
      return { number, percent, answer: Math.round((percent / 100) * number) };
    } else if (level === 2) {
      percent = level2Percents[Math.floor(Math.random() * level2Percents.length)];
      return { number, percent, answer: Math.round((percent / 100) * number) };
    } else if (level === 3) {
      combo = level3Percents[Math.floor(Math.random() * level3Percents.length)];
      const totalPercent = combo.reduce((a, b) => a + b, 0);
      const totalAnswer = Math.round((totalPercent / 100) * number);
      return { number, combo, percent: totalPercent, answer: totalAnswer };
    }
  };

  const checkAnswer = () => {
    if (currentIndex === -1) return;
    const currentQuestion = questionHistory[currentIndex];
    const parsedAnswer = parseInt(userAnswer, 10);

    if (parsedAnswer === currentQuestion.answer) {
      setFeedback("🎉 Yay! That's correct!");
      setFeedbackClass("correct");
      if (correctSound.current) correctSound.current.play();
      if (confettiRef.current) confettiRef.current.style.display = "block";

      // Automatically move to next question after 2 seconds
      setTimeout(() => nextQuestion(), 2000);
    } else {
      setFeedback(`❌ Oops! Try again. Correct answer: ${currentQuestion.answer}`);
      setFeedbackClass("wrong");
      if (wrongSound.current) wrongSound.current.play();
      if (confettiRef.current) confettiRef.current.style.display = "none";
    }
  };

  const nextQuestion = () => {
    if (currentIndex < questionHistory.length - 1) {
      // Move to existing question in history
      setCurrentIndex(currentIndex + 1);
    } else {
      // Generate a new question
      const question = generateQuestion(currentLevel);
      setQuestionHistory([...questionHistory, question]);
      setCurrentIndex(currentIndex + 1);
    }
    setUserAnswer("");
    setFeedback("");
    setFeedbackClass("");
    if (confettiRef.current) confettiRef.current.style.display = "none";
  };

  const previousQuestion = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
      setUserAnswer("");
      setFeedback("");
      setFeedbackClass("");
      if (confettiRef.current) confettiRef.current.style.display = "none";
    }
  };

  const currentQuestion = currentIndex >= 0 ? questionHistory[currentIndex] : null;

  return (
    <div style={styles.body}>
      <div style={styles.container}>
        <h1 style={styles.h1}>🎯 Percentage Practice Game</h1>

        {!currentLevel && (
          <div>
            <button style={styles.button} onClick={() => startLevel(1)}>
              Level 1 (10%, 25%, 50%)
            </button>
            <button style={styles.button} onClick={() => startLevel(2)}>
              Level 2 (Add 5%, 15%, 20%)
            </button>
            <button style={styles.button} onClick={() => startLevel(3)}>
              Level 3 (Combo %)
            </button>
          </div>
        )}

        {currentLevel && currentQuestion && (
          <div>
            <div style={styles.question}>
              {currentLevel === 3 ? (
                <>
                  Find {currentQuestion.percent}% of {currentQuestion.number} <br />
                  (Hint: {currentQuestion.combo.join("% + ")}%)
                </>
              ) : (
                <>Find {currentQuestion.percent}% of {currentQuestion.number}</>
              )}
            </div>

            <input
              type="number"
              placeholder="Type your answer"
              value={userAnswer}
              onChange={(e) => setUserAnswer(e.target.value)}
              style={styles.input}
            />
            <br />

            <button style={styles.button} onClick={checkAnswer}>✅ Submit</button>

            <div style={{ ...styles.feedback, color: feedbackClass === "correct" ? "green" : "red" }}>
              {feedback}
            </div>

            <div>
              <button style={styles.button} onClick={previousQuestion} disabled={currentIndex <= 0}>
                ⬅ Previous Question
              </button>
              <button style={styles.button} onClick={nextQuestion}>
                🔁 Next Question
              </button>
            </div>
          </div>
        )}

        <div ref={confettiRef} style={styles.confetti}></div>
      </div>

      <audio ref={correctSound} src="https://www.soundjay.com/buttons/sounds/button-09.mp3" />
      <audio ref={wrongSound} src="https://www.soundjay.com/button/beep-05.mp3" />
    </div>
  );
};

const styles = {
  body: {
    fontFamily: "'Comic Sans MS', cursive",
    background: "linear-gradient(to bottom, #fff8e1, #ffecb3)",
    textAlign: "center",
    padding: "20px",
    minHeight: "100vh",
    boxSizing: "border-box",
  },
  container: {
    background: "#ffffff",
    borderRadius: "30px",
    padding: "30px",
    maxWidth: "600px",
    margin: "auto",
    boxShadow: "0 0 25px rgba(0,0,0,0.2)",
    position: "relative",
  },
  h1: {
    color: "#f57f17",
    fontSize: "30px",
  },
  button: {
    fontSize: "18px",
    padding: "12px 24px",
    margin: "10px",
    borderRadius: "12px",
    backgroundColor: "#fdd835",
    border: "2px solid #fbc02d",
    cursor: "pointer",
    transition: "transform 0.2s",
  },
  input: {
    fontSize: "20px",
    padding: "10px",
    width: "250px",
    textAlign: "center",
    border: "3px solid #ffd54f",
    borderRadius: "10px",
    marginTop: "10px",
    margin: "0 auto",
  },
  question: {
    fontSize: "24px",
    margin: "20px 0",
    color: "#5d4037",
  },
  feedback: {
    fontSize: "22px",
    fontWeight: "bold",
    marginTop: "10px",
  },
  confetti: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    pointerEvents: "none",
    // backgroundImage: "url('https://media.giphy.com/media/3o6ZsWWhU8aPaU9U3C/giphy.gif')",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    backgroundSize: "contain",
    display: "none",
  },
};

export default PercentagePracticeGame;
